import React, { useContext } from "react";
import parse from "html-react-parser";
import { AttempsContext } from "../../context/AttemptsContext";

const criteria = [
  "tecnica",
  "coordinacion",
  "estructura",
  "creatividad",
  "cueing",
];

const UserAnswerFeedbackData = ({ canEdit, questionAnswer }) => {
  const { setUserAnswer, attempt } = useContext(AttempsContext);

  const handleFeedback = () => {
    setUserAnswer(questionAnswer);
  };

  const isGraded =
    attempt &&
    attempt.gradedAt !== null &&
    attempt.gradedAt !== undefined &&
    attempt.score !== null &&
    attempt.score !== undefined;

  return (
    <div className="container-fluid">
      {criteria.map((criteria) => (
        <div key={criteria}>
          <h5 className="text-capitalize bold h4">{criteria}</h5>
          <div className="mb-3">
            {!isGraded ? (
              <p className="small">Aún no hay feedback disponible</p>
            ) : (
              <>
                {questionAnswer[`score_${criteria}`] && (
                  <p>
                    <span className="bold">Calificación: </span>
                    {questionAnswer[`score_${criteria}`]}
                  </p>
                )}
                {questionAnswer[`feedback_${criteria}`] === null
                  ? <p className="small">Aún no hay feedback disponible</p>
                  : parse(
                      String(questionAnswer[`feedback_${criteria}`]).replaceAll(
                        "\n",
                        "<br/>",
                      ),
                    )}
              </>
            )}
          </div>
        </div>
      ))}

      {canEdit && (
        <button
          onClick={() => handleFeedback(questionAnswer)}
          className="btn btn-primary d-block"
        >
          <i className="fa fa-edit me-2"></i> Feedback
        </button>
      )}
    </div>
  );
};

export default UserAnswerFeedbackData;
